import { atom } from 'jotai'

export type CancelDateType = 'endOfBillingPeriod' | 'customDate' | 'immediate'

export const cancelDateSelectionAtom = atom<{
  cancelDateType: CancelDateType
  customDate?: Date
}>({
  cancelDateType: 'immediate'
})
